import { Input, InputProps } from 'components/UI';

const InputWhite = ({ sx, ...props }: InputProps) => (
  <Input
    {...props}
    sx={{
      bgColor: 'white',
      _focus: {
        bgColor: 'white',
      },
      _hover: {
        bgColor: 'white',
      },
      ...sx,
    }}
  />
);

export default InputWhite;
